// Romanian words a cook types → where the basic foods (USDA, English names) start (usability audit 2026-11-02:
// only 161 of 8,093 foods have a Romanian name, so a Romanian search found almost nothing). Search aid only: it
// never sets a number, the restaurant still picks the food. Curated by hand, no AI call; on 2026-11-02 every
// prefix matched at least one food of the local USDA import (8,093 foods).

/** [Romanian word as shown, English name prefixes] */
export const RO_SEARCH: [ro: string, en: string[]][] = [
  // Lactate și ouă
  ["lapte", ["Milk, whole", "Milk, reduced fat", "Milk, lowfat"]],
  ["smântână", ["Cream, sour"]],
  ["frișcă", ["Cream, fluid, heavy whipping", "Cream, whipped"]],
  ["smântână lichidă", ["Cream, fluid"]],
  ["unt", ["Butter, salted", "Butter, without salt"]],
  ["iaurt", ["Yogurt, plain", "Yogurt, Greek"]],
  ["brânză", ["Cheese, feta", "Cheese, cottage", "Cheese, ricotta"]],
  ["telemea", ["Cheese, feta"]],
  ["brânză de vaci", ["Cheese, cottage"]],
  ["cașcaval", ["Cheese, gouda", "Cheese, edam", "Cheese, cheddar"]],
  ["mozzarella", ["Cheese, mozzarella"]],
  ["parmezan", ["Cheese, parmesan"]],
  ["gorgonzola", ["Cheese, blue"]],
  ["cremă de brânză", ["Cheese, cream"]],
  ["mascarpone", ["Cheese, cream"]],
  ["ou", ["Egg, whole, raw", "Egg, whole, cooked"]],
  ["ouă", ["Egg, whole, raw", "Egg, whole, cooked"]],
  ["gălbenuș", ["Egg, yolk"]],
  ["albuș", ["Egg, white"]],
  // Carne și mezeluri
  ["pui", ["Chicken, broilers or fryers, breast", "Chicken, broilers or fryers, thigh", "Chicken, broiler"]],
  ["piept de pui", ["Chicken, broilers or fryers, breast"]],
  ["pulpe de pui", ["Chicken, broilers or fryers, thigh", "Chicken, broilers or fryers, leg"]],
  ["aripi de pui", ["Chicken, broilers or fryers, wing"]],
  ["ficat de pui", ["Chicken, liver"]],
  ["curcan", ["Turkey"]],
  ["porc", ["Pork, fresh, loin", "Pork, fresh, shoulder", "Pork, fresh"]],
  ["ceafă de porc", ["Pork, fresh, shoulder"]],
  ["cotlet de porc", ["Pork, fresh, loin"]],
  ["muschi de porc", ["Pork, fresh, loin, tenderloin"]],
  ["coaste de porc", ["Pork, fresh, spareribs"]],
  ["vită", ["Beef, ground", "Beef, loin", "Beef, chuck", "Beef, round"]],
  ["vită tocată", ["Beef, ground"]],
  ["mușchi de vită", ["Beef, loin, tenderloin"]],
  ["antricot", ["Beef, rib"]],
  ["miel", ["Lamb"]],
  ["berbecuț", ["Lamb"]],
  ["carne tocată", ["Beef, ground", "Pork, ground"]],
  ["bacon", ["Pork, cured, bacon"]],
  ["șuncă", ["Ham", "Pork, cured, ham"]],
  ["salam", ["Salami"]],
  ["cârnați", ["Sausage", "Pork sausage"]],
  ["pastramă", ["Pastrami"]],
  ["prosciutto", ["Pork, cured, ham"]],
  ["ciolan", ["Pork, cured, ham", "Pork, fresh, leg"]],
  ["rață", ["Duck"]],
  ["iepure", ["Game meat, rabbit"]],
  ["vânat", ["Game meat"]],
  // Pește și fructe de mare
  ["somon", ["Fish, salmon"]],
  ["ton", ["Fish, tuna"]],
  ["păstrăv", ["Fish, trout"]],
  ["cod", ["Fish, cod"]],
  ["doradă", ["Fish, sea bass", "Fish, snapper"]],
  ["biban de mare", ["Fish, sea bass"]],
  ["șalău", ["Fish, pike"]],
  ["crap", ["Fish, carp"]],
  ["hering", ["Fish, herring"]],
  ["sardine", ["Fish, sardine"]],
  ["hamsii", ["Fish, anchovy"]],
  ["macrou", ["Fish, mackerel"]],
  ["creveți", ["Crustaceans, shrimp"]],
  ["scoici", ["Mollusks, mussel", "Mollusks, clam"]],
  ["midii", ["Mollusks, mussel"]],
  ["vongole", ["Mollusks, clam"]],
  ["calamar", ["Mollusks, squid"]],
  ["caracatiță", ["Mollusks, octopus"]],
  ["icre", ["Fish, caviar", "Fish, roe"]],
  // Legume
  ["cartofi", ["Potatoes"]],
  ["ceapă", ["Onions"]],
  ["usturoi", ["Garlic"]],
  ["roșii", ["Tomatoes, red"]],
  ["ardei", ["Peppers, sweet", "Peppers, hot"]],
  ["castraveți", ["Cucumber"]],
  ["murături", ["Pickles"]],
  ["varză", ["Cabbage"]],
  ["morcovi", ["Carrots"]],
  ["țelină", ["Celery", "Celeriac"]],
  ["păstârnac", ["Parsnips"]],
  ["sfeclă", ["Beets"]],
  ["vinete", ["Eggplant"]],
  ["dovlecei", ["Squash, summer, zucchini"]],
  ["dovleac", ["Pumpkin"]],
  ["ciuperci", ["Mushrooms, white", "Mushrooms"]],
  ["champignon", ["Mushrooms, white"]],
  ["spanac", ["Spinach"]],
  ["salată verde", ["Lettuce"]],
  ["rucola", ["Arugula"]],
  ["broccoli", ["Broccoli"]],
  ["conopidă", ["Cauliflower"]],
  ["mazăre", ["Peas, green"]],
  ["fasole verde", ["Beans, snap"]],
  ["fasole", ["Beans, kidney", "Beans, white", "Beans, navy"]],
  ["năut", ["Chickpeas"]],
  ["linte", ["Lentils"]],
  ["porumb", ["Corn, sweet"]],
  ["praz", ["Leeks"]],
  ["ridichi", ["Radishes"]],
  ["avocado", ["Avocados"]],
  ["măsline", ["Olives"]],
  ["pătrunjel", ["Parsley"]],
  ["mărar", ["Dill weed"]],
  ["busuioc", ["Basil"]],
  ["leuștean", ["Parsley"]],
  // Fructe
  ["mere", ["Apples, raw"]],
  ["pere", ["Pears, raw"]],
  ["banane", ["Bananas"]],
  ["portocale", ["Oranges, raw"]],
  ["lămâie", ["Lemons, raw", "Lemon juice"]],
  ["lime", ["Limes, raw", "Lime juice"]],
  ["căpșuni", ["Strawberries"]],
  ["zmeură", ["Raspberries"]],
  ["afine", ["Blueberries"]],
  ["vișine", ["Cherries, sour"]],
  ["cireșe", ["Cherries, sweet"]],
  ["struguri", ["Grapes"]],
  ["ananas", ["Pineapple"]],
  ["piersici", ["Peaches"]],
  ["caise", ["Apricots"]],
  ["prune", ["Plums"]],
  ["mango", ["Mangos"]],
  ["kiwi", ["Kiwifruit"]],
  ["pepene", ["Melons", "Watermelon"]],
  ["stafide", ["Raisins"]],
  ["nucă de cocos", ["Nuts, coconut"]],
  // Cereale, paste, pâine
  ["făină", ["Wheat flour"]],
  ["orez", ["Rice, white", "Rice, brown"]],
  ["paste", ["Pasta"]],
  ["spaghete", ["Pasta"]],
  ["tăiței", ["Noodles"]],
  ["pâine", ["Bread, white", "Bread, whole-wheat", "Bread"]],
  ["chiflă", ["Rolls, hamburger or hotdog", "Rolls, dinner"]],
  ["lipie", ["Bread, pita"]],
  ["tortilla", ["Tortillas"]],
  ["blat de pizza", ["Bread, french or vienna", "Bread, pita"]],
  ["mălai", ["Cornmeal"]],
  ["mămăligă", ["Cornmeal"]],
  ["ovăz", ["Oats"]],
  ["griș", ["Semolina"]],
  ["cuscus", ["Couscous"]],
  ["quinoa", ["Quinoa"]],
  ["biscuiți", ["Cookies", "Crackers"]],
  // Uleiuri, sosuri, condimente
  ["ulei", ["Oil, sunflower", "Oil, olive", "Oil, vegetable"]],
  ["ulei de măsline", ["Oil, olive"]],
  ["ulei de floarea-soarelui", ["Oil, sunflower"]],
  ["untură", ["Lard"]],
  ["margarină", ["Margarine"]],
  ["grăsimi vegetale", ["Shortening", "Margarine"]],
  ["maioneză", ["Salad dressing, mayonnaise"]],
  ["ketchup", ["Catsup"]],
  ["muștar", ["Mustard"]],
  ["oțet", ["Vinegar"]],
  ["sos de soia", ["Soy sauce"]],
  ["sare", ["Salt, table"]],
  ["piper", ["Spices, pepper"]],
  ["boia", ["Spices, paprika"]],
  ["scorțișoară", ["Spices, cinnamon"]],
  ["oregano", ["Spices, oregano"]],
  ["cimbru", ["Spices, thyme"]],
  ["zahăr", ["Sugars, granulated"]],
  ["zahăr pudră", ["Sugars, powdered"]],
  ["miere", ["Honey"]],
  ["gem", ["Jams and preserves"]],
  ["dulceață", ["Jams and preserves"]],
  ["ciocolată", ["Chocolate, dark", "Candies, milk chocolate", "Baking chocolate"]],
  ["cacao", ["Cocoa"]],
  ["vanilie", ["Vanilla extract"]],
  ["drojdie", ["Leavening agents, yeast"]],
  ["praf de copt", ["Leavening agents, baking powder"]],
  ["amidon", ["Cornstarch"]],
  ["nuci", ["Nuts, walnuts, english"]],
  ["alune", ["Nuts, hazelnuts"]],
  ["migdale", ["Nuts, almonds"]],
  ["fistic", ["Nuts, pistachio"]],
  ["arahide", ["Peanuts"]],
  ["semințe", ["Seeds"]],
  ["susan", ["Seeds, sesame"]],
  // Băuturi
  ["apă", ["Beverages, water"]],
  ["cafea", ["Beverages, coffee"]],
  ["ceai", ["Beverages, tea"]],
  ["suc de portocale", ["Orange juice"]],
  ["suc de mere", ["Apple juice"]],
  ["suc", ["Orange juice", "Apple juice", "Grape juice"]],
  ["sirop", ["Syrups"]],
  ["bere", ["Alcoholic beverage, beer"]],
  ["vin", ["Alcoholic beverage, wine"]],
  ["vin roșu", ["Alcoholic beverage, wine, table, red"]],
  ["vin alb", ["Alcoholic beverage, wine, table, white"]],
  ["vodcă", ["Alcoholic beverage, distilled, vodka"]],
  ["rom", ["Alcoholic beverage, distilled, rum"]],
  ["whisky", ["Alcoholic beverage, distilled, whiskey"]],
  ["gin", ["Alcoholic beverage, distilled, all"]],
  ["tequila", ["Alcoholic beverage, distilled, all"]],
  ["coniac", ["Alcoholic beverage, distilled, all"]],
  ["țuică", ["Alcoholic beverage, distilled, all"]],
  ["lichior", ["Alcoholic beverage, liqueur"]],
  ["băutură răcoritoare", ["Beverages, carbonated"]],
  ["cola", ["Beverages, carbonated, cola"]],
  ["apă tonică", ["Beverages, carbonated, tonic water"]],
];

/** Lower case, without diacritics (ă â î ș ț and the cedilla forms), single spaces. */
export function plain(s: string): string {
  return s.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/\s+/g, " ").trim();
}

/**
 * Dictionary words the query names, best first: the whole query, then every entry the query starts or is
 * contained in (≥ 3 letters). "smantana" → smântână; "piept de pui la gratar" → piept de pui, pui.
 */
export function roMatches(query: string): [ro: string, en: string[]][] {
  const q = plain(query);
  if (q.length < 3) return [];
  const scored: { e: [string, string[]]; score: number }[] = [];
  for (const e of RO_SEARCH) {
    const k = plain(e[0]);
    let score = 0;
    if (k === q) score = 3;
    else if (k.startsWith(q)) score = 2;
    else if (` ${q} `.includes(` ${k} `) || q.startsWith(`${k} `)) score = 1 + k.length / 100;
    if (score) scored.push({ e, score });
  }
  return scored.sort((a, b) => b.score - a.score).map((s) => s.e);
}

/** "blat de pizza (220 g)" → { name: "blat de pizza", grams: 220 }; the format the AI run stores. */
export function parseMissing(s: string): { name: string; grams: number | null } {
  const m = /^(.*\S)\s*\((\d+(?:[.,]\d+)?)\s*g\)$/.exec(s.trim());
  return m?.[1] && m[2]
    ? { name: m[1], grams: Number(m[2].replace(",", ".")) }
    : { name: s.trim(), grams: null };
}
